import React, { useState, useEffect} from "react";
import axios from "axios";
export default function FrontVq() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  let baseURL = "https://fukuyamarccenter.com/item_view_for_json/";
  useEffect(() => {
    axios.post(
      baseURL,
      {
        action: "vq",
      },
      {
        headers: {
        'Content-Type': 'application/json',
        },
      }
      ).then((response) => {
        setData(response.data);
      }).catch((error) => {
        setError(error);
    });
    }, [baseURL]);
  if (!data) {
    return (
      <adide>Loading...</adide>
    );
  }

  return (
    <section>
      <h2 className="top_title_h2">VQmodels 飛行機</h2>
      <div className="product_box max_width">
      {data.map((item) => (
      <section className="product_box_child" key={item.id}>
        <div className="product_stock">
            <div className="product_stock_img"><a href={item.url} dangerouslySetInnerHTML={{ __html: item.img }} /></div>
            <div className="product_stock_title"><a href={item.url}><h2 dangerouslySetInnerHTML={{ __html: item.name }}></h2></a></div>
            <div className="product_stock_price" dangerouslySetInnerHTML={{ __html: item.price }} ></div>
            <div className="product_stock_icon" dangerouslySetInnerHTML={{ __html: item.stock_icon }} ></div>
        </div>
      </section>
      ))}
      </div>
    </section>
  );
}
